import { render, staticRenderFns } from "./CalendarPopover.vue?vue&type=template&id=489c687a&"
import script from "./CalendarPopover.vue?vue&type=script&lang=js&"
export * from "./CalendarPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports